<template>
  <router-link ripple class="link-tile" :to="{name: linkname}">
    <v-list-item :style="{'background-color': getRoute( linkname, 'color' )}" @click=";">
      <v-list-item-content>
        <v-list-item-title class="menu-item">{{getRoute( linkname, 'name' )}}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </router-link>
</template>

<style>
  .link-tile {
    font-size: 24px !important;
    font-weight: bold !important;
    text-decoration: none !important;
  }
  .menu-item {
    color: #FFFFFF;
  }
</style>

<script>
  export default {
    name: 'routerlink',
    props: {
      linkname: String
    },

    methods: {
      getRoute(name, key) {
        return this.$router.options.routes.find(r => r.name == name).meta[key]
      },
    },
  }
</script>
